import { AUTH, CLOSE_SOCKET, CREATE_SOCKET, FETCH_HISTORIC_NOTIFICATIONS, FETCH_MORE_HISTORIC_NOTIFICATIONS, LOGOUT, MARK_NOTIFICATIONS_AS_READ, NOTIFICATION_FROM_SOCKET, REPOPULATE, SHOW_NOTIFICATIONS, UPDATE_PROFILE } from '../constants/actionTypes';

const notificationsReducer = (state = {notifications: [], popupNotifications: null, show: false}, action) => {

    switch (action.type) {

        case FETCH_HISTORIC_NOTIFICATIONS:

            return {

                notifications: [
                    ...action.data.data
                ],
                total: action.data.total,
                totalUnread: action.data.totalUnread,
                numberOfPages: action.data.numberOfPages,
                currentPage: action.data.currentPage
            }
                

        case FETCH_MORE_HISTORIC_NOTIFICATIONS: 
            //socket should have been closed in actions, remove from state here
            
            return {

                notifications: [
                    ...state.notifications,
                    ...action.data.data
                ],
                total: action.data.total,
                totalUnread: action.data.totalUnread,
                numberOfPages: action.data.numberOfPages,
                currentPage: action.data.currentPage
            }


        case NOTIFICATION_FROM_SOCKET:

            //check if notification is already present in array from historic notifications

            let prevPopups = state.popupNotifications || []; 

            return {
                ...state,
                notifications: [
                    action.data.notification,
                    ...state.notifications,
                ],
                totalUnread: state.totalUnread+1,
                popupNotification: action.data.notification
            }

        case MARK_NOTIFICATIONS_AS_READ:

            let adjustedNotifications = state.notifications.map(notification => {

                if(action.ids.includes(notification._id)){
                    notification.read = true;
                }

                return notification; 
            }); 

            return {
                ...state,
                notifications: adjustedNotifications,
                totalUnread: action.data.totalUnread
            }

        default:
            return state; 
    }
}

export default notificationsReducer; 